import { Component, Input } from '@angular/core';
import {AssetModel} from "../../models/asset.model";
import {AssetsService} from "../../assets/assets.service";
import { UtilsService } from '../../shared/utils.service';

/**
 * Renders the restricted public asset details. It is used inline by the QR scan handler
 * (`HandleQrCodeComponent`), which supplies the public asset payload via the `asset` input.
 */
@Component({
  selector: 'app-noauth-asset-public-details',
  templateUrl: './noauth-asset-public-details.component.html',
  styleUrls: ['./noauth-asset-public-details.component.scss']
})
export class NoauthAssetPublicDetailsComponent {

  @Input() asset = new AssetModel();

  constructor(
    public assetsService: AssetsService,
    public utils: UtilsService
  ) {}
}
